import castArray from 'lodash/castArray'

export default report

/** @ngInject */
function report(Contract, ReportManager, PotManager, ErrorCatcher) {
    return ({
        restrict: 'E',
        template: require('./report.jade')(),
        scope: {
            userInfo: '=',
        },
        link($scope) {
            $scope.errors = {
                display: false,
            }
            $scope.canForceWarning = false
            $scope.errorMessages = null
            $scope.newReport = {}
            $scope.report = ReportManager

            const refreshReport = function () {
                $scope.report.updateClass('read')
                return PotManager.update()
            }

            $scope.enableReport = function () {
                $scope.report.updateClass('input')
                ReportManager.message = null
            }

            $scope.closeErrors = () => {
                $scope.errors.display = false
            }

            $scope.updateReport = function (newReport, force = false) {
                if ((($scope.userInfo.contractSelected.plan === 'Base') && newReport.base) || (newReport.hp && newReport.hc)) {
                    $scope.errors.display = false
                    if ($scope.userInfo.contractSelected) {
                        return Contract.report({ id: $scope.userInfo.contractSelected.id, force }, newReport).$promise
                        .then((response) => {
                            if (response && response.status === 'SUCCESS') {
                                $scope.newReport = {}
                                return Contract.get({ id: $scope.userInfo.contractSelected.id }).$promise
                                .then((contract) => {
                                    ReportManager.updateContract(contract)
                                    return refreshReport()
                                }).then(() => {
                                    ReportManager.message = 'Votre relève a bien été enregistrée.'
                                })
                            } else if (response && response.status === 'WARNING') {
                                ReportManager.message = response.message
                                $scope.errorMessages = [ReportManager.message]
                                $scope.errors.display = true
                                $scope.canForceWarning = true
                            } else {
                                if (response && response.type) {
                                    switch (response.type) {
                                        case 'LINKY':
                                            ReportManager.message = 'Les auto-relèves ne sont pas acceptées pour les compteurs Linky.'
                                            break
                                        case 'ENEDIS':
                                            ReportManager.message = 'Une erreur technique est survenue lors de la transmission à Enedis.'
                                            break
                                        case 'CONS_INF_0':
                                            ReportManager.message = 'La relève saisie est inférieure à la dernière relève réelle. Nous vous recontacterons pour vous indiquer la marche à suivre.'
                                            break
                                        default:
                                            ReportManager.message = 'Une erreur technique est survenue.'
                                    }
                                } else {
                                    ReportManager.message = 'Une erreur technique est survenue.'
                                }
                                $scope.errorMessages = [ReportManager.message]
                                $scope.errors.display = true
                                $scope.canForceWarning = false
                            }
                        })
                        .catch((error) => {
                            if (error.data && error.data.error && error.data.error.message && (error.data.error.canForce !== undefined)) {
                                $scope.errors.display = true
                                $scope.canForceWarning = error.data.error.canForce
                                $scope.errorMessages = castArray(error.data.error.message)
                            } else {
                                let message = 'Une erreur s’est produite.  Votre relève n’a pas été enregistrée.'
                                if (error.data && error.data.error && error.data.error.message && error.data.error.display) {
                                    ({ message } = error.data.error)
                                }
                                ReportManager.message = message
                                refreshReport()
                            }
                            return ErrorCatcher.catchError(error)
                        })
                    }
                } else {
                    return refreshReport()
                }
            }

            const activate = () => ReportManager.updateContract($scope.userInfo.contractSelected)

            return activate()
        },
    })
}



// WEBPACK FOOTER //
// ./src/directives/report/report.js